import { WebPlugin } from '@capacitor/core';
export class PrintWeb extends WebPlugin {
    async printPdf(options) {
        console.log("print length " + options.base64Data.length);
    }
}
//# sourceMappingURL=web.js.map